import { Injectable } from '@angular/core';
import { DbEntityProvider } from './db-entity.provider';
import { DbDaoService, GetAllDataOptions } from '../db/db-dao.service';
import { UPDATES_TYPES } from '../../constants/updates-types.const';
import { Observable } from 'rxjs';
import { ProductVariant } from '../../classes/product-variant.class';
import { Query } from '@paymash/capacitor-database-plugin';

@Injectable()
export class ProductVariantProvider extends DbEntityProvider {
  constructor(dbDaoService: DbDaoService) {
    super(UPDATES_TYPES.ProductVariant.type, dbDaoService);
  }

  getByUuid(uuid: string): Observable<ProductVariant> {
    return <Observable<ProductVariant>>this.getEntityByUuid(uuid);
  }

  getList(): Observable<ProductVariant[]> {
    return <Observable<ProductVariant[]>>this.getEntitiesList();
  }

  getListByParams(queryParams: Query, options?: GetAllDataOptions): Observable<ProductVariant[]> {
    return <Observable<ProductVariant[]>>this.getEntitiesListByParams(queryParams, options).pipe(this.mapPipeTransformEntities());
  }
}
